import { useMemo } from 'react'

import { formatMs } from './Swimlane'

import styles from './StatBand.module.scss'

import type { AttributionRow, SpeakerMapping } from '@/pages/app/AttributionViewer/artifactDerivations'

type StatCard = {
  value: string
  label: string
}

const distinctSpeakers = (rows: AttributionRow[]): number =>
  new Set(rows.map((row) => row.speaker?.key).filter((key): key is string => key != null)).size

const StatBand = ({
  endMs,
  liveRows,
  observationCount,
  rawRows,
  chorusRows,
  refinedRows,
  speakerMappings,
}: {
  endMs: number
  liveRows: AttributionRow[]
  observationCount: number
  rawRows: AttributionRow[]
  chorusRows: AttributionRow[]
  refinedRows: AttributionRow[]
  speakerMappings: SpeakerMapping[]
}) => {
  const rawClusters = useMemo(() => distinctSpeakers(rawRows), [rawRows])
  const resolvedPeople = useMemo(
    () => new Set(speakerMappings.flatMap((mapping) => (mapping.personId == null ? [] : [mapping.personId]))).size,
    [speakerMappings]
  )
  const cards: StatCard[] = [
    { value: formatMs(endMs), label: 'meeting length' },
    { value: String(liveRows.length), label: 'live entries' },
    { value: String(observationCount), label: 'tile events' },
    { value: String(rawClusters), label: 'Soniox clusters' },
    { value: String(distinctSpeakers(chorusRows)), label: 'Chorus clusters' },
    { value: String(refinedRows.length), label: 'shipped entries' },
    { value: String(resolvedPeople), label: 'people resolved' },
  ]

  return (
    <div className={styles.band}>
      {cards.map((card) => (
        <div key={card.label} className={styles.card}>
          <span className={styles.value}>{card.value}</span>
          <span className={styles.label}>{card.label}</span>
        </div>
      ))}
    </div>
  )
}

export default StatBand
